import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { applicationErrorMessage } from "../lib/applicationErrors.mjs";

export default function CandidateApplicationsPanel() {
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(0);
  const [result, setResult] = useState({ items: [], total: 0, pages: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    api.get("/applications/mine", { params: { page, size: 20 } }).then(({ data }) => {
      if (!active) return;
      if (!Array.isArray(data?.items) || !Number.isInteger(data.pages) || !Number.isInteger(data.total)) {
        throw new Error("Invalid application history response");
      }
      if (page > Math.max(1, data.pages)) {
        setPage(Math.max(1, data.pages));
        return;
      }
      setResult(data);
      setLoading(false);
    }).catch((failure) => {
      if (!active) return;
      setError(applicationErrorMessage(failure, "Unable to load your applications. Please try again."));
      setLoading(false);
    });
    return () => { active = false; };
  }, [page, reload]);

  const refresh = () => {
    setLoading(true);
    setError("");
    setReload((value) => value + 1);
  };
  const changePage = (value) => {
    setLoading(true);
    setError("");
    setPage(value);
  };

  return (
    <section className="card p-6" data-testid="applications-panel">
      <div className="flex flex-wrap justify-between items-center gap-2">
        <h2 className="text-lg font-semibold">Applications{!loading && !error ? " (" + result.total + ")" : ""}</h2>
        <button type="button" className="btn btn-ghost py-1 px-3" disabled={loading} onClick={refresh}>Refresh</button>
      </div>
      {loading ? <p role="status" className="mt-3 text-sm text-slate-500">Loading applications…</p> : error ? <>
        <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>
        <button type="button" className="btn btn-primary mt-3" onClick={refresh}>Retry loading applications</button>
      </> : <>
        <ul className="mt-3 space-y-2 text-sm">
          {result.items.map((application) => (
            <li key={application.id} className="flex flex-wrap justify-between gap-2">
              <span>{application.job_title} · {application.company_name}</span>
              <span className="pill bg-slate-100 text-slate-700">{(application.stage || "").replace(/_/g, " ")}</span>
            </li>
          ))}
          {result.total === 0 && <li className="text-slate-500">No applications yet. <Link className="text-[#1d4ed8] underline" to="/jobs">Search vacancies</Link>.</li>}
        </ul>
        {result.pages > 1 && <nav aria-label="Application history pages" className="mt-4 flex flex-wrap items-center gap-3 text-sm">
          <button type="button" className="btn btn-ghost py-1 px-3" disabled={page <= 1} onClick={() => changePage(page - 1)}>Previous</button>
          <span>Page {page} of {result.pages}</span>
          <button type="button" className="btn btn-ghost py-1 px-3" disabled={page >= result.pages} onClick={() => changePage(page + 1)}>Next</button>
        </nav>}
      </>}
    </section>
  );
}
